import {
    Box,
    Button,
    Divider,
    Heading,
    HStack,
    Text,
    useDisclosure,
    VStack,
} from "@chakra-ui/react";
import ChangeNicknameModal from "./component/ChangeNicknameModal";
import ChangeEmailModal from "./component/ChangeEmailModal";
import { useUser } from "../../context/UserContext";

const Account = () => {
    const user = useUser()

    const { isOpen: isOpenChangeNickname, onOpen: onOpenChangeNickname, onClose: onCloseChangeNickname } = useDisclosure();
    const { isOpen: isOpenChangeEmail, onOpen: onOpenChangeEmail, onClose: onCloseChangeEmail } = useDisclosure();
    
    return (
        <VStack align={"flex-start"} gap={10} mb={25}>
            <Box width={"100%"}>
                <HStack alignItems={'center'}>
                    <Heading size={"md"} m={0}>Change nickname</Heading>
                    <Text m={0} fontSize={"md"} color={"gray.700"}>
                        ({user.nickname || ""})
                    </Text>
                </HStack>
                <Divider borderColor={"gray.300"} />
                <Text>
                    Changing your nickname can have unintended side effects.
                </Text>
                <Button variant={"outline"} onClick={onOpenChangeNickname}>
                    Change nickname
                </Button>
                <ChangeNicknameModal
                    isOpen={isOpenChangeNickname}
                    onOpen={onOpenChangeNickname}
                    onClose={onCloseChangeNickname}
                />
            </Box>

            <Box width={"100%"}>
                <HStack alignItems={'center'}>
                    <Heading size={"md"} m={0}>Change email</Heading>
                    <Text m={0} fontSize={"md"} color={"gray.700"}>
                        ({user.email || ""})
                    </Text>
                </HStack>
                
                <Divider borderColor={"gray.300"} />
                <Text>
                    Changing your email can have unintended side effects.
                </Text>
                <Button variant={"outline"} onClick={onOpenChangeEmail}>
                    Change email
                </Button>
                <ChangeEmailModal
                    isOpen={isOpenChangeEmail}
                    onOpen={onOpenChangeEmail}
                    onClose={onCloseChangeEmail}
                />
            </Box>

            <Box width={"100%"}>
                <Heading size={"md"}>Export account data</Heading>
                <Divider borderColor={"gray.300"} />
                <Text>Export your profile metadata and your FQL history</Text>
                <Button variant={"outline"}>Start export</Button>
            </Box>

            <Box width={"100%"}>
                <Heading size={"md"}>Delete account</Heading>
                <Divider borderColor={"gray.300"} />
                <Text>This action is irreversible</Text>
                <Button variant={"danger-outline"}>Delete your account</Button>
            </Box>
        </VStack>
    );
};

export default Account;
